import "../styles/style.css";
import { dateToWords } from "../util/helperFunctions";

function MessageSeparator(props) {
  const { date } = props;
  return <span className="message__date-seperator">{dateToWords(date)}</span>;
}

export default MessageSeparator;
